import { render, staticRenderFns } from "./SkillsReport.vue?vue&type=template&id=6ba6dc74&scoped=true&"
import script from "./SkillsReport.vue?vue&type=script&lang=js&"
export * from "./SkillsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba6dc74",
  null
  
)

export default component.exports